export enum RoadnetServiceLabels {
  toastErrorAuth = 'No se pudo realizar la autenticación en Roadnet'
}
